import FORM_CONFIG from './bulkUpdateTestCasesForm.formConfigConstant';

export const getFields = () => {
  return {
    ...FORM_CONFIG,
  };
};

export default getFields;
